import { toast } from "react-toastify";
import { handleAppError } from "./errorHandler";

export const SuccessToast = (message, options = {}) => {
  toast.success(message, {
    type: "success",
    ...options,
  });
};

export const ErrorToast = (message, options = {}) => {
  toast.error(message, {
    type: "error",
    ...options,
  });
};

export const WarningToast = (message, options = {}) => {
  toast.warning(message, {
    type: "warning",
    ...options,
  });
};

export const InfoToast = (message, options = {}) => {
  toast.info(message, {
    type: "info",
    ...options,
  });
};

export const ErrorHandler = (errorObj, options = {}) => {
  const error = handleAppError(errorObj);
  return toast.error(error, { type: "error", ...options });
};
